"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var web_utils_1 = require("@ubeeqo/web-utils");
var axios_client_service_1 = require("../../../../axios-client/axios-client.service");
var user_company_account_const_1 = require("./user-company-account.const");
/**
 * UserCompanyAccountService
 * @class
 */
var UserCompanyAccountService = /** @class */ (function () {
    function UserCompanyAccountService() {
    }
    /**
     * Retrieves a company details based on it's companyUuid
     * @param companyUuid {string}
     * @returns Promise<Company>
     */
    UserCompanyAccountService.prototype.getCompanyDetail = function (companyUuid, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.getCompanyDetail
            .replace('{{version}}', version)
            .replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Updates a price markup for a company based on it's companyUuid
     * @param companyUuid {string}
     * @param data<object>
     * @returns Promise<Company>
     */
    UserCompanyAccountService.prototype.putPricingData = function (companyUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.putPricingData
            .replace('{{version}}', version)
            .replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Updates a price markup for a user based on userUuid
     * @param userUuid {string}
     * @param data<object>
     * @returns Promise<Company>
     */
    UserCompanyAccountService.prototype.patchUserDetail = function (userUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.patchUserDetail
            .replace('{{version}}', version)
            .replace('{{userUuid}}', userUuid);
        return axios_client_service_1.axiosClientInstance.patch(url, data);
    };
    /**
     * Checks vality of company's email (`companyEmail`)
     * @param companyEmail {string}
     * @returns
     */
    UserCompanyAccountService.prototype.getCheckCompanyEmail = function (companyEmail, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.getCheckCompanyEmail
            .replace('{{version}}', version)
            .replace('{{companyEmail}}', companyEmail);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Creates a new company entry
     * @param data<Company>
     * @returns
     */
    UserCompanyAccountService.prototype.createCompany = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.createCompany.replace('{{version}}', version);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Links a new company entry to a given user account(`idpUuid`)
     * @param idpUuid {string}
     * @param data<Company>
     * @returns
     */
    UserCompanyAccountService.prototype.createCompanyLinkedToAccount = function (idpUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.postCreateCompanyLinkedToAccount
            .replace('{{version}}', version)
            .replace('{{idpUuid}}', idpUuid);
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    /**
     * Updated company data bound to user (`companyUuid`) - by `idp`
     * @param companyUuid {string}
     * @param data<CompanyPartial>
     * @returns
     */
    UserCompanyAccountService.prototype.putUpdateCompany = function (companyUuid, data, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.putUpdateCompany
            .replace('{{version}}', version)
            .replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.put(url, data);
    };
    /**
     * Checkif a company exists by country, filcal_number and language
     * @param data<object>
     */
    UserCompanyAccountService.prototype.getCompanyPreRegister = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var query = web_utils_1.toQueryString(data);
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.getCompanyPreRegister
            .replace('{{version}}', version)
            .replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * get Ubeeqo Titles
     * @param data<object>
     */
    UserCompanyAccountService.prototype.getUbeeqoTitles = function (data, version) {
        if (version === void 0) { version = 'v1'; }
        var query = web_utils_1.toQueryString(data);
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.getUbeeqoTitles
            .replace('{{version}}', version)
            .replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    /**
     * Checks vality of company's emails (`emails`)
     * @param companyUuid {string}
     * @param emails Emails
     * @param version
     * @returns
     */
    UserCompanyAccountService.prototype.postCheckCompanyEmails = function (companyUuid, emails, version) {
        if (version === void 0) { version = 'v1'; }
        var url = user_company_account_const_1.USER_COMPANY_ACCOUNT_ENDPOINT.postCheckCompanyEmails
            .replace('{{version}}', version)
            .replace('{{companyUuid}}', companyUuid);
        return axios_client_service_1.axiosClientInstance.post(url, emails);
    };
    return UserCompanyAccountService;
}());
/**
 * External UserCompanyAccountService Class Instance
 * @namespace
 */
exports.userCompanyAccount = new UserCompanyAccountService();
